import { LANDING } from '@/constants/testIds';

const tiers = [
  {
    stage: '01',
    name: 'Foundation',
    code: 'SHU',
    principle: 'Discipline',
    description: 'Learn the rules before breaking them. Structured baseline drills that establish how your eyes currently perform — and where the gaps live.',
  },
  {
    stage: '02',
    name: 'Sharpen',
    code: 'HA',
    principle: 'Disruption',
    description: 'Variable load. Sport-specific noise. The drills break rhythm on purpose — building adaptable competence that transfers to unpredictable play.',
  },
  {
    stage: '03',
    name: 'Elite',
    code: 'RI',
    principle: 'Transcendence',
    description: 'Vision becomes a way of seeing, not a skill to remember. The training disappears. What remains is instinct, sharpened by data.',
  },
];

const TiersSection = () => {
  return (
    <section
      id="tiers"
      data-testid={LANDING.tiersSection}
      className="relative py-24 md:py-32"
    >
      {/* Section divider line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-signal-gold/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-16 md:mb-20">
          <p className="font-mono text-signal-gold text-xs tracking-widest uppercase mb-4">
            How it works
          </p>
          <h2
            data-testid={LANDING.tiersSectionTitle}
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-bone tracking-tight"
          >
            Scored weekly. Trained daily.
          </h2>
          <p className="font-body text-slate text-base md:text-lg mt-5 max-w-xl">
            Three stages of development. Each tier builds on the last — from discipline, through disruption, to transcendence.
          </p>
        </div>

        {/* Tiers grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
          {tiers.map((tier) => (
            <div
              key={tier.stage}
              data-testid={`${LANDING.tierCard}-${tier.stage}`}
              className="border-t border-white/10 pt-8 pb-12 md:pr-12 last:md:pr-0 group relative"
            >
              {/* Animated gold top border on hover */}
              <div className="absolute top-0 left-0 w-0 h-px bg-signal-gold transition-all duration-700 group-hover:w-full" />

              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-mono text-signal-gold text-sm font-medium tracking-wider">
                  STAGE {tier.stage}
                </span>
                <span className="font-mono text-slate/50 text-xs tracking-widest uppercase">
                  {tier.code}
                </span>
              </div>

              <h3 className="font-heading text-2xl font-semibold text-bone mb-2">
                {tier.name}
              </h3>

              <p className="font-mono text-signal-gold/70 text-xs tracking-widest uppercase mb-5">
                {tier.principle}
              </p>

              <p className="font-body text-slate text-sm leading-relaxed">
                {tier.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TiersSection;
